
import { defineComponent, reactive } from 'vue'

export default defineComponent({
  name: "homepage",
  created(){
    
  }
})
